import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { format } from "lib/globalize-util";
import theme from "styles/theme";
import { openBulkManager, addBulkAction } from "actions/utilities/bulk-manager-actions";
import Catalogs from "./bulk-catalogs";
import Catalog from "models/catalog";
import ActionButton from "components/form/action-button";
import Entry from "models/catalog/entry";
import fetch from "lib/fetch";
import Dialog from "components/dialog";
import TextField from "components/form/text-field";
import { Form } from "formsy-react";
import debounce from "lodash/debounce";
import { Link } from "react-router";
import { FormatMessage } from "react-globalize";
import { VIEWPORT_MOBILE } from "constants/media";
import MenuItem from "material-ui/MenuItem";
import IconMenu from "material-ui/IconMenu";
import IconButton from "material-ui/IconButton";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import CancelIcon from "material-ui/svg-icons/navigation/cancel";
import MoreIcon from "material-ui/svg-icons/navigation/more-vert";
import moment from "moment";
import CatalogDeliveryWindows from "components/catalog/header/catalog-delivery-windows";
import { DATATEST } from "constants/integration";
import { Restriction, setValues, setOption } from "components/catalog/header/restrictions";
import _ from "lodash";
import fp from "lodash/fp";
import { getCatalogSummaryMessage } from "helpers/catalog-entries";
import { MODE } from "constants/restrictions";
import { gtm } from "helpers/gtm";
import { BulkActionProcessingStatus } from "helpers/utils/bulk-manager";

const { WHITELIST } = MODE;

const styles = {
    container: {},
    dialog: {
        // move dialog to top instead of center of page
        paddingTop: "0px",
    },
    dialogContent: {
        maxWidth: "720px",
    },
    actionButton: {
        marginLeft: "16px",
    },
    actionButtonBlock: {
        display: "block",
        width: "100%",
        marginBottom: "16px",
    },
    actionButtonBlockBottom: {
        display: "block",
        width: "100%",
    },
    buttonLabelStyle: {
        padding: "0 28px",
    },
    title: {
        fontWeight: "800",
    },
    radio: {
        display: "inline-block",
        width: "30%",
    },
    input: {
        marginTop: "8px",
        width: "100%",
    },
    cancelSearch: {
        position: "absolute",
        top: "11rem",
        right: "3rem",
        cursor: "pointer",
    },
    catalogDeliveryWindows: {
        marginTop: "24px",
        marginBottom: "24px",
    },
    subtitle: {
        fontSize: "14px",
        width: "60%",
        marginTop: "14px",
    },
};

class BulkCatalogAddItem extends Component {
    static contextTypes = {
        me: PropTypes.object.isRequired,
    };

    static propTypes = {
        activeList: PropTypes.object,
        bulkItems: PropTypes.object,
        catalogType: PropTypes.oneOf(["custom-list", "linesheet"]),
        currentCatalog: PropTypes.object,
        filters: PropTypes.object,
        item: PropTypes.object,
        type: PropTypes.oneOf(["item", "catalog"]),
        entities: PropTypes.object,
        notes: PropTypes.string,
        onActiveListAdd: PropTypes.func.isRequired,
        onActiveListFetchEntries: PropTypes.func,
        onActiveListRemove: PropTypes.func,
        onAdd: PropTypes.func,
        onRequestClose: PropTypes.func.isRequired,
        onSetActiveList: PropTypes.func,
        open: PropTypes.bool.isRequired,
        scope: PropTypes.object,
        sortBy: PropTypes.string,
        sortOrder: PropTypes.string,
        onSnackbarAdd: PropTypes.func.isRequired,
        viewport: PropTypes.string,
        searchTerm: PropTypes.string,
        deliveryWindows: PropTypes.array.isRequired,
        fetchingWindows: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        catalogType: "custom-list",
    };

    constructor(props) {
        super(props);

        const options = getDefaultOptions(props.scope.brand);
        const restrictions = getRestrictions(props.scope.brand);

        this.state = {
            openCatalogCreate: false,
            search: "",
            options,
            groups: setValues(options.groups, restrictions.values, "customer_group"),
            warehouses: setValues(options.warehouses, options.warehouses, "warehouse"),
            positionToAdd: "bottom",
            temporaryCatalogTitle: "",
            selectedCatalogs: [],
            createdCatalogs: [],
            titleError: "",
            ...this.handleFormatTemporaryCatalog(props),
        };

        this.handleCreateNewList = this.handleCreateNewList.bind(this);
        this.handleNewCatalogNameChange = this.handleNewCatalogNameChange.bind(this);
        this.handlePromptCancel = this.handlePromptCancel.bind(this);
        this.handlePromptForCatalogName = this.handlePromptForCatalogName.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleSearch = debounce(this.handleSearch.bind(this), 750);
        this.handleCancelSearch = this.handleCancelSearch.bind(this);
        this.handleDeliveryWindowChange = this.handleDeliveryWindowChange.bind(this);
        this.handleSelectionChange = this.handleSelectionChange.bind(this);
        this.handleShowBulkManager = this.handleShowBulkManager.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { scope = {}, currentCatalog } = this.props;
        const options = getDefaultOptions(scope.brand);
        const restrictions = getRestrictions(scope.brand);

        const useCatalogWarehouses = !!scope.brand.getPreference("set_warehouse_for_linesheets");
        const currentCatalogRestrictions = _.keyBy(currentCatalog?.restrictions, "value");
        const selectedWarehouses = useCatalogWarehouses
            ? _.filter(options.warehouses, (w) => currentCatalogRestrictions[w.value])
            : options.warehouses;

        this.setState({
            groups: setValues(options.groups, restrictions.values, "customer_group"),
            warehouses: selectedWarehouses,
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (
            this.props.bulkItems &&
            nextProps.bulkItems &&
            this.props.bulkItems.allSelected !== nextProps.bulkItems.allSelected
        ) {
            this.setState({
                ...this.handleFormatTemporaryCatalog(nextProps),
            });
        }
    }

    componentWillUnmount() {
        this._unmounted = true;
    }

    checkIfLinesheetsAreCatalogs = () => {
        const { scope } = this.props;
        return scope && scope.brand && scope.brand.hasPreference("linesheets_are_catalogs");
    };

    handlePositionChange = (e, value) => {
        this.setState({ positionToAdd: value });
    };

    handleAddItemToNewList(catalog) {
        const { me } = this.context;
        const {
            item,
            bulkItems,
            filters,
            searchTerm,
            currentCatalog,
            notes,
            activeList,
            onActiveListAdd,
            onActiveListRemove,
            onActiveListFetchEntries,
            type,
            entities,
            onSnackbarAdd,
            sortBy,
            sortOrder,
            scope,
            onAddBulkAction,
        } = this.props;
        const { positionToAdd } = this.state;

        const updateActiveList = onActiveListAdd && catalog?.type !== "linesheet";
        const catalogType = catalog?.type === "linesheet" ? "linesheet" : "list";
        const { items, value } = gtm.formatItemsWithBulk({
            items: { single: item, bulk: bulkItems },
            props: { entities, scope },
            list: { affiliation: catalogType, item_list_id: catalog?.id, item_list_name: catalog?.title },
        });
        gtm.emit(
            gtm.events.addToWishlist({
                currency: me._activeCurrency,
                items,
                value,
                send_to: gtm.groups.Brand,
            })
        );
        if (item) {
            const entry = new Entry();
            if (updateActiveList) {
                onActiveListAdd(item._id);
            }
            entry.save(
                {
                    item_id: item._id,
                    type: "item",
                    catalogId: catalog.id,
                    notes: notes,
                    company: scope.viewAs && scope.viewAs._id,
                },
                {
                    success: () => {
                        me.trackAction("Add item to catalog", {
                            selectAll: false,
                            createNew: true,
                            bulk: false,
                            type: catalogType,
                        });
                        me.trackAction("Create new catalog", {
                            type: catalogType,
                            withItems: true,
                        });
                    },
                    error: (model, { statusCode }) => {
                        if (statusCode !== 409) {
                            onActiveListRemove(item._id);
                        }
                    },
                }
            );
        } else if (bulkItems && bulkItems.size) {
            // assume bulk action
            let data;
            const itemFilters = bulkItems.toFilters((id) => (type === "item" ? id : entities.entries[id].item_id));
            if (bulkItems.allSelected) {
                data = filters ? filters.toJS() : {};
                data.__sort = sortBy;
                data.__sort_order = sortOrder;
                if (searchTerm) {
                    data.__search = searchTerm;
                }

                if (currentCatalog) {
                    data.__catalog_id = currentCatalog.id;
                }

                // Filter disabled products
                data.__archived = false;
                const active = data.__active || "active";
                delete data.__active;
                switch (active) {
                    case "all":
                        data.__view_disabled = true;
                        break;
                    case "inactive":
                        data.__view_disabled = true;
                        data.__active = false;
                        break;
                    case "active":
                    default:
                        data.__active = true;
                        data.__view_disabled = false;
                }
                Object.assign(data, itemFilters);
            } else {
                data = {
                    __sort: sortBy,
                    __sort_order: sortOrder,
                    __catalog_id: currentCatalog ? currentCatalog.id : undefined,
                    ...itemFilters,
                };
            }

            if (scope.viewAs) {
                data.__company = [scope.viewAs._id];
            }

            if (positionToAdd) {
                data.__position = positionToAdd;
            }
            const useWarehouseValidation = scope?.brand?.hasPreference("set_warehouse_for_linesheets");
            const route = useWarehouseValidation
                ? `/api/v3.1/catalog/${catalog.id}/entries/bulk/summarized`
                : `/api/v3.1/catalog/${catalog.id}/entries/bulk`;
            const payload = {
                id: catalog.id,
                brandId: scope.brand._id,
                name: catalog.title,
                route,
                method: "POST",
                data,
                status: BulkActionProcessingStatus.PROCESSING,
            };
            onAddBulkAction(payload);
            fetch(route, { method: "POST", body: JSON.stringify(data) })
                .then((response) => {
                    if (response.status > 300) {
                        if (!bulkItems.allSelected) {
                            onActiveListRemove(data._id);
                        }
                        return response.json().then((data) => {
                            throw new Error(data.message || format("Bad response from server"));
                        });
                    }
                    return response.json().then((data = {}) => {
                        const { createdEntries = [] } = data;

                        onAddBulkAction({
                            ...payload,
                            status: BulkActionProcessingStatus.SUCCESS,
                            error: null,
                        });

                        me.trackAction("Add item to catalog", {
                            selectAll: bulkItems.allSelected,
                            createNew: true,
                            bulk: !item,
                            type: catalog.type === "linesheet" ? "linesheet" : "list",
                        });
                        me.trackAction("Create new catalog", {
                            type: catalog.type === "linesheet" ? "linesheet" : "list",
                            withItems: true,
                        });

                        if (updateActiveList && !bulkItems.allSelected) {
                            onActiveListAdd(_.map(createdEntries, "item_id"));
                        }

                        if (bulkItems.allSelected && activeList.current && catalog.id === activeList.current.id) {
                            onActiveListFetchEntries();
                        }

                        if (useWarehouseValidation) {
                            onSnackbarAdd?.({ message: getCatalogSummaryMessage(catalog, data) });
                            return data.entries;
                        }
                        return data;
                    });
                })
                .catch((e) => {
                    onAddBulkAction({
                        ...payload,
                        status: BulkActionProcessingStatus.ERROR,
                        error: data.message || format("Bad response from server"),
                    });
                });
        }
    }

    handleShowBulkManager = () => {
        const { onOpenBulkManager, catalogType, scope } = this.props;
        const type =
            catalogType === "custom-list"
                ? format("lists")
                : scope.brand.hasPreference("linesheets_are_catalogs")
                  ? format("catalogs")
                  : format("linesheets");
        onOpenBulkManager(type);
    };

    handleFormSubmit = async () => {
        const { onAddBulkAction, scope, item, bulkItems } = this.props;
        const { selectedCatalogs } = this.state;
        if (!item && bulkItems && bulkItems.size) {
            for (const catalog of selectedCatalogs) {
                onAddBulkAction({
                    id: catalog.id,
                    brandId: scope.brand._id,
                    name: catalog.title,
                    status: BulkActionProcessingStatus.READY,
                });
            }
            this.handleShowBulkManager();
        }
        for (const catalog of selectedCatalogs) {
            const result = await this.handleAddItemToNewList(catalog);
        }
        this.handleClose();
    };

    handleClose() {
        this.setState({ selectedCatalogs: [], createdCatalogs: [], temporaryCatalogTitle: "", titleError: "" });
        this.props.onRequestClose();
    }

    handleFormatTemporaryCatalog(props = this.props) {
        const { scope, currentCatalog, item, bulkItems, entities } = props;
        const requireCatalogDates = scope.brand.getPreference("require_catalog_dates");
        const minimumDeliveryWindow = scope.brand.getPreference("minimum_delivery_window");

        const temporaryCatalog = {};
        if (requireCatalogDates) {
            const defaultDeliveryWindow = scope.brand.preferences.get("default_delivery_window");
            let itemForDates = null;
            temporaryCatalog.delivery_window_start = moment.utc();
            temporaryCatalog.delivery_window_end = moment
                .utc(temporaryCatalog.delivery_window_start)
                .add(defaultDeliveryWindow, "days");
            if (currentCatalog) {
                temporaryCatalog.delivery_window_start = currentCatalog.delivery_window_start
                    ? moment.utc(currentCatalog.delivery_window_start)
                    : moment.utc();
                temporaryCatalog.delivery_window_end = currentCatalog.delivery_window_end
                    ? moment.utc(currentCatalog.delivery_window_end)
                    : moment.utc().add(defaultDeliveryWindow, "days");
                temporaryCatalog.prebook = currentCatalog.prebook;
            } else if (item) {
                itemForDates = item;
            } else {
                if (bulkItems && bulkItems.size) {
                    if (bulkItems.allSelected) {
                        temporaryCatalog.delivery_window_start = moment.utc();
                        temporaryCatalog.delivery_window_end = moment
                            .utc(temporaryCatalog.delivery_window_start)
                            .add(defaultDeliveryWindow, "days");
                    } else {
                        const firstBulkItemId = bulkItems.first();
                        itemForDates = entities && entities.items[firstBulkItemId];
                    }
                }
            }
            if (itemForDates) {
                temporaryCatalog.delivery_window_start = itemForDates.__available_from.isBefore(moment.utc())
                    ? moment.utc()
                    : itemForDates.__available_from;
                temporaryCatalog.delivery_window_end = moment
                    .utc(temporaryCatalog.delivery_window_start)
                    .add(defaultDeliveryWindow, "days");
            }
        }

        return {
            temporaryCatalog,
            requireCatalogDates,
            minimumDeliveryWindow,
        };
    }

    handleNewCatalogNameChange(e, value) {
        this.setState({ temporaryCatalogTitle: value });
    }

    handleCreateNewList() {
        const { catalogType, onSetActiveList, onSnackbarAdd } = this.props;
        const { temporaryCatalog, temporaryCatalogTitle, groups, warehouses } = this.state;

        if (_.isEmpty(temporaryCatalogTitle)) {
            this.setState({ titleError: format("Field Required") });
            return;
        }

        let title = temporaryCatalogTitle;
        this.setState({ openCatalogCreate: false });

        if (_.isEmpty(title)) {
            title =
                catalogType === "custom-list"
                    ? format("Untitled List")
                    : format(`Untitled ${this.checkIfLinesheetsAreCatalogs() ? "Catalog" : "Linesheet"}`);
        }

        const catalog = new Catalog({
            title,
            active: catalogType === "custom-list",
            type: catalogType,
            restrictions: catalogType === "linesheet" ? [...groups, ...warehouses] : warehouses,
            ...temporaryCatalog,
        });

        catalog.save(null, {
            success: () => {
                if (onSetActiveList && catalogType === "custom-list") {
                    onSetActiveList(catalog, { fetch: false });
                }
                this.setState({
                    openCatalogCreate: false,
                    createdCatalogs: [...this.state.createdCatalogs, catalog],
                    selectedCatalogs: [...this.state.selectedCatalogs, catalog],
                    temporaryCatalogTitle: "",
                    titleError: "",
                });
                onSnackbarAdd({
                    message: (
                        <span>
                            <FormatMessage
                                path="Catalog created"
                                variables={{ catalog: catalog.title }}
                                elements={{ link: <Link to={catalog._link} /> }}
                            />
                        </span>
                    ),
                });
            },
            error: (rawResponse, status, response) => {
                const defaultError =
                    catalogType === "custom-list"
                        ? format("Error creating list")
                        : format(`Error creating ${this.checkIfLinesheetsAreCatalogs() ? "catalog" : "linesheet"}`);
                onSnackbarAdd({ message: response.message || defaultError });
            },
        });
    }

    handlePromptForCatalogName() {
        this.setState({ openCatalogCreate: true, temporaryCatalogTitle: "", titleError: "" });
    }

    handlePromptCancel() {
        this.setState({ openCatalogCreate: false });
    }

    handleSearch(listSearch) {
        this.setState({ listSearch });
    }

    handleSearchChange(event, listSearch) {
        this.setState({ search: listSearch });
        this.handleSearch(listSearch);
    }

    handleCancelSearch() {
        this.setState({ search: "" });
        this.handleSearch("");
    }

    handleDeliveryWindowChange(windowChanges) {
        const { minimumDeliveryWindow } = this.state;
        let requiredValidation = false;
        if (windowChanges.delivery_window_start && !windowChanges.delivery_window_end) {
            delete windowChanges.delivery_window_end;
            requiredValidation = true;
        }

        const temporaryCatalog = {
            ...this.state.temporaryCatalog,
            ...windowChanges,
        };

        if (temporaryCatalog.delivery_window_start) {
            temporaryCatalog.delivery_window_start = moment.isMoment(temporaryCatalog.delivery_window_start)
                ? temporaryCatalog.delivery_window_start
                : moment.utc(temporaryCatalog.delivery_window_start);
        }

        if (temporaryCatalog.delivery_window_end) {
            temporaryCatalog.delivery_window_end = moment.isMoment(temporaryCatalog.delivery_window_end)
                ? temporaryCatalog.delivery_window_end
                : moment.utc(temporaryCatalog.delivery_window_end);
        }

        if (requiredValidation) {
            if (
                temporaryCatalog.delivery_window_start
                    .clone()
                    .add(minimumDeliveryWindow, "days")
                    .isAfter(temporaryCatalog.delivery_window_end)
            ) {
                temporaryCatalog.delivery_window_end = temporaryCatalog.delivery_window_start
                    .clone()
                    .add(minimumDeliveryWindow, "days");
            }
        }

        this.setState({ temporaryCatalog });
    }

    handleSelectionChange = ({ added = [], removed = [] }) => {
        const { selectedCatalogs } = this.state;
        this.setState({
            selectedCatalogs: _.uniqBy([...selectedCatalogs, ...added], (catalog) => catalog.id).filter(
                (catalog) => !removed.some((row) => row.id === catalog.id)
            ),
        });
    };

    render() {
        const {
            open,
            item,
            bulkItems,
            filters,
            entities,
            type,
            searchTerm,
            catalogType,
            currentCatalog,
            notes,
            scope,
            sortBy,
            onSnackbarAdd,
            sortOrder,
            viewport,
            fetchingWindows,
            deliveryWindows,
        } = this.props;
        const smallLayout = viewport === "mobile" || viewport === "phablet" || viewport === "tablet";
        const { positionToAdd } = this.state;
        const linesheetTerm = this.checkIfLinesheetsAreCatalogs() ? format("catalog") : format("linesheet");
        const linesheetsTerm = this.checkIfLinesheetsAreCatalogs() ? format("catalogs") : format("linesheets");
        const capitalizedLinesheetTerm = _.capitalize(linesheetTerm);

        const useCatalogWarehouses = !!scope.brand.getPreference("set_warehouse_for_linesheets");

        const {
            openCatalogCreate,
            search,
            listSearch,
            requireCatalogDates,
            temporaryCatalog,
            groups,
            warehouses,
            options,
            temporaryCatalogTitle,
            selectedCatalogs,
            createdCatalogs,
        } = this.state;

        const isMobile = viewport === VIEWPORT_MOBILE;

        const searchForm = (
            <Form>
                <TextField
                    hintText={
                        catalogType === "custom-list" ? format("Search Lists") : format(`Search ${linesheetsTerm}`)
                    }
                    large={false}
                    style={styles.input}
                    hintStyle={{ padding: "0px 0px 5px 16px" }}
                    onChange={this.handleSearchChange}
                    value={search}
                    name="list-search"
                    allowWhitespace={true}
                    autoFocus={!openCatalogCreate}
                    dataTest={DATATEST.GALLERY.SEARCH_INPUT}
                />
                {search && (
                    <CancelIcon
                        color={theme.palette.grey}
                        style={styles.cancelSearch}
                        onClick={this.handleCancelSearch}
                    />
                )}
            </Form>
        );

        let dialogTitle, buttonLabel;
        let actionButtons = [];

        if (!open) {
            return null;
        }

        if (openCatalogCreate) {
            dialogTitle = catalogType === "custom-list" ? format("New list") : format(`New ${linesheetTerm}`);
            actionButtons = [
                <ActionButton
                    key="back"
                    data-test={DATATEST.MODAL_PROMPT_CANCEL}
                    label={format("Back")}
                    styles={{ marginLeft: "10px" }}
                    onClick={this.handlePromptCancel}
                />,
                <ActionButton
                    key="submit"
                    data-test={DATATEST.MODAL_PROMPT_CONFIRM}
                    styles={{ marginLeft: "10px" }}
                    label={format("Create")}
                    onClick={this.handleCreateNewList}
                    primary={true}
                />,
            ];
        } else {
            if (item || bulkItems) {
                if (catalogType === "custom-list") {
                    dialogTitle = format("Add to list");
                    buttonLabel = format("+ New list");
                } else {
                    dialogTitle = format(`Add to ${linesheetTerm}`);
                    buttonLabel = format(`+ New ${linesheetTerm}`);
                }
            } else {
                dialogTitle = format("Select Active List");
                buttonLabel = format("Create New List");
            }
            actionButtons = [
                <ActionButton
                    key="new"
                    styles={{ float: "left", marginLeft: "5px" }}
                    outline={true}
                    onClick={this.handlePromptForCatalogName}
                    label={buttonLabel}
                    data-test={DATATEST.GALLERY.BULK_CREATE_NEW_CATALOG}
                />,
                <ActionButton
                    key="cancel"
                    type="submit"
                    styles={smallLayout ? styles.actionButtonBlock : styles.actionButton}
                    labelStyle={styles.buttonLabelStyle}
                    label={format("Cancel")}
                    disabled={false}
                    onClick={this.handleClose}
                />,
                <ActionButton
                    data-test={DATATEST.GALLERY.BULK_ADD_TO_CATALOG}
                    key="done"
                    type="submit"
                    styles={smallLayout ? styles.actionButtonBlockBottom : styles.actionButton}
                    labelStyle={styles.buttonLabelStyle}
                    label={format("Done")}
                    primary={true}
                    disabled={_.isEmpty(this.state.selectedCatalogs)}
                    onClick={this.handleFormSubmit}
                />,
            ];
        }

        return (
            <div>
                <Dialog
                    title={dialogTitle}
                    modal={true}
                    autoScrollBodyContent={false}
                    open={open}
                    onRequestClose={openCatalogCreate ? this.handlePromptCancel : this.handleClose}
                    style={styles.dialog}
                    contentStyle={styles.dialogContent}
                    titleStyle={styles.title}
                    actions={actionButtons}
                >
                    <div id="bulk-add-to-existing" style={{ display: openCatalogCreate ? "none" : "block" }}>
                        <RadioButtonGroup
                            name="position"
                            valueSelected={positionToAdd}
                            onChange={this.handlePositionChange.bind(this)}
                        >
                            <RadioButton
                                data-test={DATATEST.GALLERY.BULK_ADDTO_BOTTOM}
                                key="bottom"
                                value="bottom"
                                label={format("Add to bottom")}
                                style={styles.radio}
                            />
                            <RadioButton
                                data-test={DATATEST.GALLERY.BULK_ADDTO_TOP}
                                key="top"
                                value="top"
                                label={format("Add to top")}
                                style={styles.radio}
                            />
                        </RadioButtonGroup>
                        {searchForm}
                        <p style={styles.subtitle}>
                            {format(`Select up to 20 ${catalogType === "custom-list" ? "lists" : linesheetsTerm}`)}
                        </p>
                        <div style={styles.container}>
                            <Catalogs
                                selectedCatalogs={selectedCatalogs}
                                filters={filters}
                                listSearch={listSearch}
                                searchTerm={searchTerm}
                                sortBy={sortBy}
                                sortOrder={sortOrder}
                                catalogType={catalogType}
                                onSelectionChange={this.handleSelectionChange}
                                createdCatalogs={createdCatalogs}
                            />
                            {isMobile && (
                                <IconMenu
                                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                    targetOrigin={{ vertical: "top", horizontal: "right" }}
                                    iconStyle={{ fill: "#333" }}
                                    iconButtonElement={
                                        <IconButton>
                                            <MoreIcon />
                                        </IconButton>
                                    }
                                    style={styles.button}
                                >
                                    <MenuItem
                                        primaryText={buttonLabel}
                                        data-test={DATATEST.GALLERY.BULK_CREATE_NEW_CATALOG}
                                        onClick={this.handlePromptForCatalogName}
                                    />
                                </IconMenu>
                            )}
                        </div>
                    </div>
                    <div id="bulk-add-to-new" style={{ display: openCatalogCreate ? "block" : "none" }}>
                        <Form>
                            <TextField
                                key="new-catalog-name"
                                name="new-catalog-name"
                                placeholder={format("Please enter name")}
                                label={
                                    catalogType === "custom-list"
                                        ? format("List name")
                                        : format(`${capitalizedLinesheetTerm} name`)
                                }
                                dataTest={DATATEST.MODAL_PROMPT_INPUT}
                                allowWhitespace={true}
                                fullWidth={true}
                                required={openCatalogCreate}
                                large={true}
                                value={temporaryCatalogTitle}
                                onChange={this.handleNewCatalogNameChange}
                                autoFocus={openCatalogCreate}
                                errorText={this.state.titleError}
                            />
                        </Form>
                        <div style={styles.catalogDeliveryWindows}>
                            <CatalogDeliveryWindows
                                catalog={temporaryCatalog}
                                editable={true}
                                scope={scope}
                                deliveryWindows={deliveryWindows}
                                onDeliveryWindowChange={this.handleDeliveryWindowChange}
                                deliveryWindowStart={temporaryCatalog.delivery_window_start}
                                deliveryWindowEnd={temporaryCatalog.delivery_window_end}
                                prebook={!!temporaryCatalog.prebook}
                                fetchingWindows={fetchingWindows}
                                requireCatalogDates={requireCatalogDates}
                                isNewModalEnabled={true}
                            />
                        </div>
                        {scope.brand.modules.base.customer_groups.length > 0 && catalogType === "linesheet" && (
                            <Restriction
                                dataTest={DATATEST.CATALOG.ALLOWED_CUSTOMER_GROUPS_SELECTOR}
                                label={format("Allowed customer groups")}
                                placeholder={format("No customer groups")}
                                onChange={this.handleChangeRestrictions("groups")}
                                options={options.groups}
                                values={groups}
                                isNewModalEnabled={true}
                            />
                        )}
                        {useCatalogWarehouses && (
                            <Restriction
                                errorText={format("Field Required")}
                                dataTest={DATATEST.CATALOG.VISIBLE_WAREHOUSES_SELECTOR}
                                label={format("Warehouse")}
                                placeholder={format("Select warehouse")}
                                onChange={this.handleChangeRestrictions("warehouses")}
                                options={options.warehouses}
                                values={warehouses}
                                mode={MODE.WHITELIST}
                                isNewModalEnabled={true}
                            />
                        )}
                    </div>
                </Dialog>
            </div>
        );
    }

    handleChangeRestrictions = (field) => (values) => {
        this.setState({ [field]: values });
    };
}

const getDefaultOptions = (brand = {}) => {
    return {
        groups: _.map(brand.modules?.base.customer_groups, (group) =>
            setOption("customer_group", group._id, group.name)
        ),
        warehouses: fp.compose(
            fp.map(({ name, _id }) => setOption("warehouse", _id, name, WHITELIST)),
            fp.orderBy(["created_on"], ["desc"])
        )(brand.settings?.warehouses),
    };
};

const getRestrictions = (brand = {}) => {
    return {
        values: _.map(
            brand?.modules?.base?.customer_groups?.filter((group) => group.exclude === true),
            (group) => setOption("customer_group", group._id, group.name)
        ),
    };
};

const mapStateToProps = (state, ownProps) => {
    return {
        bulkManager: state.bulkManager,
        activeList: state.activeList,
        bulkItems: state.bulkItems,
        scope: state.scope,
        deliveryWindows: state.deliveryWindows.predefined.payload || [],
        fetchingWindows: state.deliveryWindows.predefined.isFetching || false,
        entities: state.entities,
        viewport: state.app.viewport,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onOpenBulkManager: (type) => dispatch(openBulkManager(type)),
        onAddBulkAction: (payload) => dispatch(addBulkAction(payload)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(BulkCatalogAddItem);
